import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { CardBody } from '../../components/card/card';
import { getListPeopleCount, getListPeopleJump, getListPeopleLean, getListPintuSelatan, getListPintuUtara } from '../../redux/action/summaryAction';

const CardCount = () => {
  const dispatch = useDispatch()
  const { dataPPLCNT,dataPPLLEN, dataPPLJMP, dataSelatan, dataUtara } = useSelector((state) => state.summary)
  let { siteId } = useParams()
  const { user } = useSelector((state) => state.auth)
  // console.log(user)
  const param = {
    token: user.access_token,
    siteId: siteId
  }
  // console.log(siteId)
  


  useEffect(() => {
    dispatch(getListPeopleCount(param));
    dispatch(getListPeopleJump(param));
    dispatch(getListPeopleLean(param));
    dispatch(getListPintuSelatan(param));
    dispatch(getListPintuUtara(param));
  }, []);
  const Card = ( value, title) => {
    return (
      <div className="card" style={{ border: '1px solid #7b7b7b' }}>
        <div className="card-body">
          <div className='row'>
            
            <div className="d-flex fw-bold small mb-3" style={{textAlign: 'center'}}>
              <span className="flex-grow-1 fs-15px">{title}</span>
            </div>
            <div className="col-xl-12 col-lg-12" style={{ marginBottom: 5, textAlign: 'center' }}>
              <span className="mb-2 fs-5 text-truncate" style={{paddingLeft: '10px', textAlign:'center'}}>
                {value}
              </span>
            </div>  
          </div>
        </div>
      </div>
    )   
  }
  return (
    <>
      <div className='col-xl-4 col-lg-4' style={{ paddingTop: '30px'}}>
        {Card( dataPPLCNT.reduce((acc, entry) => acc + entry.sum, 0) , 'Total Pengguna')}
      </div>
      {/* <div className='col-xl-2 col-lg-2' style={{ paddingTop: '30px'}}>
        {Card(  '-' , 'Pintu Halte')}
      </div>
      <div className='col-xl-2 col-lg-2' style={{ paddingTop: '30px'}}>
        {Card(  '-' , 'Pintu Barat')}
      </div>
      <div className='col-xl-2 col-lg-2' style={{ paddingTop: '30px'}}>
        {Card( '-' , 'Pintu Timur')}
      </div> */}
      <div className='col-xl-4 col-lg-4' style={{ paddingTop: '30px'}}>
        {Card( dataSelatan.length > 0 ? dataSelatan[0].sum : '-' , 'Pintu Timur')}
      </div>
      <div className='col-xl-4 col-lg-4' style={{ paddingBottom: '20px',paddingTop: '30px'}}>  
        {Card( dataUtara.length > 0 ? dataUtara[0].sum : '-' , 'Pintu Barat')}
      </div>
      <div className='col-xl-6 col-lg-12' style={{ paddingBottom: '20px'}}>  
        {Card( dataPPLLEN.length > 0 ? dataPPLLEN[0].sum : '-' , 'Jumlah Orang Bersandar')}
      </div>
      <div className='col-xl-6 col-lg-12' style={{ paddingBottom: '20px'}}>  
        {Card( dataPPLJMP.length > 0 ? dataPPLJMP[0].sum : '-' , 'Jumlah Berpotensi Melompat')}
      </div>
    </>
  )
}
export default CardCount
